import { defineStore } from 'pinia';
import { nextTick, ref } from 'vue';

export enum ScrollEventLabels {
    FEED_POSTS = 'feed-posts',
}
export const useUIStore = defineStore('ui', () => {
    // Track scroll targets with their identifiers
    const scrollTargets = ref<Record<string, () => void>>({});
    
    // Register a scroll function for a specific target
    const registerScrollTarget = (id: string, scrollFn: () => void) => {
        scrollTargets.value[id] = scrollFn;
    };
    
    // Unregister a scroll target
    const unregisterScrollTarget = (id: string) => {
        delete scrollTargets.value[id];
    };
    
    // Trigger scroll for a specific target
    // const scrollToTop = (targetId: string) => {
    //     if (scrollTargets.value[targetId]) {
    //         scrollTargets.value[targetId]();
    //     }
    // };
     const scrollToTop = (targetId: string) => {
        const scrollFn = scrollTargets.value[targetId];
        if (scrollFn) {
            // Use nextTick to ensure DOM is updated
            nextTick(() => {
                scrollFn();
            });
        }
    };
    return {
        scrollTargets,
        registerScrollTarget,
        unregisterScrollTarget,
        scrollToTop
    };
});